import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChequeRemittanceApiService } from './cheque-remittance.api.service';
import { ChequeRemittanceEffects } from './cheque-remittance.effects';
import {
  IChequeRemittanceState,
  chequeRemittanceReducer,
  chequeRemittanceInitialState,
} from './cheque-remittance.reducer';
import { ChequeRemittanceService } from './cheque-remittance.service';
import { chequeRemittanceFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IChequeRemittanceState>(
      chequeRemittanceFeatureKey,
      chequeRemittanceReducer,
      {
        initialState: chequeRemittanceInitialState,
      }
    ),
    EffectsModule.forFeature([ChequeRemittanceEffects]),
  ],
  providers: [ChequeRemittanceApiService, ChequeRemittanceService],
})
export class StoreChequeRemittanceModule {}
